import { type UseQueryResult, useQuery } from 'react-query';
import {
  EsppOfferingPeriodService,
  PagedResultDto_EsppOfferingPeriodRow,
  // eslint-disable-next-line camelcase
} from '@wealthlane/api-services/wealthlane-award-service';
import { TableParams, type TableParamsType } from '../../types/common';
import { ParticipantBrokerAccountService } from '@wealthlane/api-services/wealthlane-customer-service';

const useGetParticipantBrokerList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParams
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_EsppOfferingPeriodRow | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount, companyId, brokerStatusId, brokerIds } =
    tableInfo;

  const participantBrokerList = useQuery(
    [
      'getParticipantBrokerList',
      filter,
      sorting,
      skipCount,
      maxResultCount,
      companyId,
      brokerStatusId,
      brokerIds,
    ],
    async () => {
      return await handleRequest(
        ParticipantBrokerAccountService.getApiCustomerApiAppParticipantBrokerAccountParticipantList(
          [companyId],
          [],
          [],
          [],
          [brokerStatusId],
          true,
          [brokerIds],
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return participantBrokerList;
};

export default useGetParticipantBrokerList;
